﻿/* globals FilterIndexDTO */
var jquery = require("jquery");
var HabEvents = require("../../Global/habitaclia-events");

(function () {
    "use strict";
    var FilterIndex = function (FilterIndexDTO) {
        this.__zonasSeleccionadas = [];
        this.__distritosSeleccionados = [];
        this.__FilterDTO = FilterIndexDTO;
        this.__$pvpMin = jquery("#FiltrosViewModel_Filtros_PvpMin");
        this.__$pvpMax = jquery("#FiltrosViewModel_Filtros_PvpMax");

        __registerEvents.call(this);
        __initData.call(this);
        
    };

    var __initData = function(){

        if (jquery("#hab" + this.__FilterDTO.numhab).length > 0)
        {
            jquery("#hab" + this.__FilterDTO.numhab).addClass("select");
        }
        jquery("#FiltrosViewModel_Filtros_HabMin").val(this.__FilterDTO.numhab);

        if (jquery("#ban" + this.__FilterDTO.numbanos).length > 0) {
        	jquery("#ban" + this.__FilterDTO.numbanos).addClass("select");
        }
        jquery("#FiltrosViewModel_Filtros_BanosMin").val(this.__FilterDTO.numbanos);

        this.__FilterDTO.codZonasSel =  jquery("#FiltrosViewModel_Filtros_CodZonas").val();
        this.__FilterDTO.codDistsSel = jquery("#FiltrosViewModel_Filtros_CodDistritos").val();

    };

    var __initModalZonas = function () {
        var numZonasPoblacion = jquery("#modal-zonas input:checkbox.z").length;
        var numDistritosPoblacion = jquery("#modal-zonas input:checkbox.d").length;
        __InitZonas_De_DistritoSeleccionado();

        if (this.__distritosSeleccionados.length > 0)
        {
            if (numDistritosPoblacion === this.__distritosSeleccionados.length && numZonasPoblacion === this.__zonasSeleccionadas.length) {
                __checkUnckeckAll.call(this, true);
            } else {
                __checkUnckeckAll.call(this, false);
                jquery("#modal-zonas #l-z-all").addClass("algoseleccionado");

                for (var i = 0, length = this.__distritosSeleccionados.length; i < length; i++) {
                    var distrito = this.__distritosSeleccionados[i];
                    var $inputD = jquery("#modal-zonas #d-" + distrito.codDist);
                    var $span = jquery("#modal-zonas #span-nomdist-" + distrito.codDist);
                    $inputD.val("1");
                    $inputD.prop("checked", true);

                    var numeroZonasPorDistrito = jquery("#modal-zonas #ul-d-" + distrito.codDist + " input:checkbox.z").length;

                    if (numeroZonasPorDistrito === distrito.numZonasSeleccionadas){
                        $inputD.addClass("zonaseleccionada");
                        $span.addClass("zonaseleccionada");
                        $span.removeClass("zonanoseleccionada");
                    } else {
                        $inputD.addClass("algoseleccionado");
                    }

                    for (var j = 0, lengthZ = this.__zonasSeleccionadas.length; j < lengthZ; j++) {
                        var zona = this.__zonasSeleccionadas[j];
                        var $input = jquery("#z-" + zona.codZona + "-" + distrito.codDist);
                        if ($input.length > 0){
                            $input.val("1");
                            $input.prop("checked", true);
                            var $label = $input.parent();
                            $label.removeClass("zonanoseleccionada");
                            $label.addClass("zonaseleccionada");
                        }
                    }
                }
            }

        } else {
            if (numZonasPoblacion === this.__zonasSeleccionadas.length) {
                __checkUnckeckAll.call(this, true);
            } else if (this.__zonasSeleccionadas.length > 0) {
                __checkUnckeckAll.call(this, false);
                jquery("#modal-zonas #l-z-all").addClass("algoseleccionado");
                for (var k = 0, lengthK = this.__zonasSeleccionadas.length; k < lengthK; k++) {
                    var zonaK = this.__zonasSeleccionadas[k];
                    var $inputK = jquery("#z-" + zonaK.codZona + "-0");
                    $inputK.val("1");
                    $inputK.prop("checked", true);
                    var $labelK = $inputK.parent();
                    $labelK.removeClass("zonanoseleccionada");
                    $labelK.addClass("zonaseleccionada");
                }
            }
        }               
    };

    var __registerEvents = function () {
        var self = this;

        var numHabAnterior = "#hab" + this.__FilterDTO.numhab;

        jquery("#hab0, #hab1, #hab2, #hab3, #hab4, #hab5").click(function () {
            jquery(numHabAnterior).removeClass("select");
            jquery("#" + this.id).addClass("select");
            numHabAnterior = "#" + this.id; 

            jquery("#FiltrosViewModel_Filtros_HabMin").val(jquery(this).attr("data-num-hab"));
        });

        var numBanosAnterior = "#ban" + this.__FilterDTO.numbanos;

        jquery("#ban0, #ban1, #ban2, #ban3").click(function () {
        	jquery(numBanosAnterior).removeClass("select");
        	jquery("#" + this.id).addClass("select");
        	numBanosAnterior = "#" + this.id;

        	jquery("#FiltrosViewModel_Filtros_BanosMin").val(jquery(this).attr("data-num-ban"));
        });

        jquery("#FiltrosViewModel_Filtros_SelectedPoblacion").change(function () {
            var poblacion = jquery(this).val().split("-");

            if (poblacion.length === 4) {
                jquery("#FiltrosViewModel_Filtros_Geo_CodPob").val(poblacion[1]);
                jquery("#FiltrosViewModel_Filtros_Geo_CodArea").val(poblacion[2]);

                var zona = poblacion[3];
                if (zona === "0")
                {
                    jquery("#zona").addClass("ocultar");
                }
                else if (zona === "1")
                {
                    //La población tiene zonas
                    __loadModalZonas(self.__FilterDTO);
                    jquery("#zona").removeClass("ocultar");
                }

                jquery("#FiltrosViewModel_Filtros_CodZonas").val("");
                jquery("#FiltrosViewModel_Filtros_CodDistritos").val("");
                jquery("#SelectZona").html("<ul><li>" + self.__FilterDTO.todas + "</li></ul>");
            }
        });

        jquery("#filtrar").click(function () {
            
            var listaFiltros = "";
            var tipsInm2 = "";
            var ids = "";
            var checksFiltros = jquery('.chkfiltros:checked');
            var validacionesCorrectas = true;
           
            for(var i = 0; i < checksFiltros.length; i++){
                listaFiltros = listaFiltros + (checksFiltros[i].value) + '_';
            }

            if (listaFiltros.length > 0) {
                listaFiltros = listaFiltros.substring(0, listaFiltros.length - 1);
            }
            
            jquery("#FiltrosViewModel_Filtros_FiltrosAvanzados").val(listaFiltros);

            var numTipinm = jquery(".chksubtipos").length;

            if (numTipinm > 0)
            {
                var numTipinmSelected = jquery(".chksubtipos:checked").length;
                if (numTipinmSelected === 0)
                {
                    alert("Para poder filtrar tienes que seleccionar como mínimo un tipo de inmueble");
                    validacionesCorrectas = false;
                }

                var subtiposSeleccionados = jquery(".chksubtipos:checked");

                if (numTipinm === subtiposSeleccionados.length) {
                    tipsInm2 = '';
                    ids = '';
                } else {
                    subtiposSeleccionados.each(function (index, item) {
                        tipsInm2 += item.getAttribute("data-tipsInm2") + ",";
                        ids += item.getAttribute("id") + ",";
                    });


                    if (tipsInm2.length > 0) {
                        tipsInm2 = tipsInm2.substring(0, tipsInm2.length - 1);
                    }

                    if (ids.length > 0) {
                        ids = ids.substring(0, ids.length - 1);
                    }
                }
                     
                jquery("#FiltrosViewModel_Filtros_TipsInm2").val(tipsInm2);
                jquery("#FiltrosViewModel_Filtros_TipInmAgrupado").val(ids);
            }

            if (validacionesCorrectas)
            {
                document.forms.FiltroInmuebles.action = self.__FilterDTO.urlformlistado;
                document.forms.FiltroInmuebles.submit();
            }
        });

        jquery("#cancelar").click(function () {
            document.forms.FiltroInmuebles.reset();
  
            jquery("#FiltrosViewModel_Filtros_Geo_CodPob").val(self.__FilterDTO.codPob);
            jquery("#FiltrosViewModel_Filtros_Geo_CodArea").val(self.__FilterDTO.codArea);
            jquery("#FiltrosViewModel_Filtros_CodZonas").val(self.__FilterDTO.codZonasSel);
            jquery("#FiltrosViewModel_Filtros_CodDistritos").val(self.__FilterDTO.codDistsSel);
            jquery("#FiltrosViewModel_Filtros_HabMin").val(self.__FilterDTO.numhab);
            jquery("#FiltrosViewModel_Filtros_BanosMin").val(self.__FilterDTO.numbanos);

            document.forms.FiltroInmuebles.action = self.__FilterDTO.urlformlistado;
            document.forms.FiltroInmuebles.submit();
        });

        jquery("#resetfiltros").click(function () {

            jquery("#FiltrosViewModel_Filtros_PvpMax option:eq(0)").prop('selected', true);
            jquery("#FiltrosViewModel_Filtros_PvpMin option:eq(0)").prop('selected', true);
            jquery("#FiltrosViewModel_Filtros_SupMin option:eq(0)").prop('selected', true);
            jquery("#FiltrosViewModel_Filtros_FiltroPeriodo option:eq(0)").prop('selected', true);

            jquery("#FiltrosViewModel_Filtros_SelectedPoblacion option:eq(0)").prop('selected', true);
            jquery("#SelectZona").html("<ul><li>" + self.__FilterDTO.todas + "</li></ul>");
            jquery("#FiltrosViewModel_Filtros_CodZonas").val("");
            jquery("#FiltrosViewModel_Filtros_CodDistritos").val("");
            jquery("#FiltrosViewModel_Filtros_Geo_CodDist").val("");

            jquery("#hab0").addClass("select");
            jquery("#hab1, #hab2, #hab3, #hab4, #hab5").removeClass("select");
            jquery("#FiltrosViewModel_Filtros_HabMin").val(0);
            numHabAnterior = "#hab0";

            jquery("#ban0").addClass("select");
            jquery("#ban1, #ban2, #ban3").removeClass("select");
            jquery("#FiltrosViewModel_Filtros_BanosMin").val(0);
            numBanosAnterior = "#ban0";

            var tipimps = jquery("#tipimp input:checkbox:not(:checked)");
            tipimps.each(function (i, tipimp) {
                jquery(tipimp).prop("checked", true);
            });

            var filtrosav = jquery("#filtrosav input:checkbox:checked");
            filtrosav.each(function (i, filtroav) {
                jquery(filtroav).prop("checked",false);
            });

            jquery("#msg-filtros-reseteados").fadeIn(300);

            setTimeout(function () {
                jquery("#msg-filtros-reseteados").fadeOut(300);
            }, 2000);

            self.__zonasSeleccionadas =[];
            self.__distritosSeleccionados =[];

        });

        jquery("#SelectZona").click(function () {
            var title = jquery("#wmTitle span").html();
            var codPais = jquery("#FiltrosViewModel_Filtros_Geo_CodPais").val();
            var codProv = jquery("#FiltrosViewModel_Filtros_Geo_CodProv").val();
            var codCom = jquery("#FiltrosViewModel_Filtros_Geo_CodCom").val();
            var codArea = jquery("#FiltrosViewModel_Filtros_Geo_CodArea").val();
            var codPob = jquery("#FiltrosViewModel_Filtros_Geo_CodPob").val();
            var selectedZones = __getAllSelected.call(self);
            window.FilterMapDTO = {
                title: title,
                mapData: 'codPais=' + codPais + '&codProv=' + codProv + '&codCom='+codCom+'&codArea='+codArea+'&codPob='+codPob,
                selectedZones: selectedZones,
                halfSelectedZones: []
            };
            var openCloseEvent = new window.Event('openCloseFilterModal');
            window.dispatchEvent(openCloseEvent);
            __registerEventsModalZonas.call(self);
            __initModalZonas.call(self);
        });

        this.__$pvpMin.change(function (e) {
            var currentPrice = jquery(e.currentTarget).children('option:selected')[0].value;
            __updatePvpMax.call(self, currentPrice);
            jquery.publish(HabEvents.EventsEnum.ChangePvpMin);
        });
        this.__$pvpMax.change(function (e) {
            var currentPrice = jquery(e.currentTarget).children('option:selected')[0].value;
            __updatePvpMin.call(self, currentPrice);
            jquery.publish(HabEvents.EventsEnum.ChangePvpMax);
        });

        window.addEventListener('newZonesSelected', function () {

            var poblacionSeleccionada = __getPoblacionSeleccionada();
            var distritosSeleccionados;
            var zonasSeleccionadas;
            if (poblacionSeleccionada.length>0) {
                jquery("#FiltrosViewModel_Filtros_CodDistritos").val("");
                jquery("#FiltrosViewModel_Filtros_CodZonas").val("");
            }else{
                distritosSeleccionados = __getDistritosSeleccionados();
                zonasSeleccionadas = __getZonasSeleccionadas();

                self.__zonasSeleccionadas = zonasSeleccionadas;
                self.__distritosSeleccionados = distritosSeleccionados;

                var codZonasSeleccionados = __getStringFromArray(zonasSeleccionadas, "codZona");
                var codDistritosSeleccionados = __getStringFromArray(distritosSeleccionados, "codDist");


                jquery("#FiltrosViewModel_Filtros_CodDistritos").val(codDistritosSeleccionados);
                jquery("#FiltrosViewModel_Filtros_CodZonas").val(codZonasSeleccionados);
            }

            __setZonasSeleccionadas.call(self, poblacionSeleccionada, distritosSeleccionados, zonasSeleccionadas);
        });

    };

    var __getAllSelected = function () {
        var codDist = document.getElementById('FiltrosViewModel_Filtros_CodDistritos').value;
        var codZonas = document.getElementById('FiltrosViewModel_Filtros_CodZonas').value;
        if (codZonas === '' && codDist === '') {
            return [];
        } else if (codDist === '' && codZonas !== '') {
            return codZonas.split(',').map(function (zone) { return { id: parseInt(zone), type: "zone" }; });
        } else if (codZonas === '' && codDist !== '') {
            return codDist.split(',').map(function (zone) { return { id: parseInt(zone), type: "district" }; });
        }else {
            var zones = codZonas.split(',').map(function (zone) { return { id: parseInt(zone), type: "zone" }; });
            var dist = codDist.split(',').map(function (zone) { return { id: parseInt(zone), type: "district" }; });
            var filteredZones = zones;
            dist.forEach(dist => {
                const firsNumber = String(dist.id).charAt(0);
                filteredZones = filteredZones.filter(zone=> {
                    return !String(zone.id).startsWith(firsNumber);
                });
            });
            return [...filteredZones, ...dist];
        }
    };

    var __updatePvpMin = function (currentPrice) {
        var self = this;
        var actualSelected = this.__$pvpMin.children(':selected')[0].value;
        currentPrice = parseInt(currentPrice);
        this.__$pvpMin.html('');
        for (var i = 0; i<this.__FilterDTO.priceList.length; i++) {
            if (i === 0) {
                self.__$pvpMin.append('<option value="0">Sin límite</option>');
            }
            var price = this.__FilterDTO.priceList[i];
            if (parseInt(price) < currentPrice || currentPrice===0) {
                self.__$pvpMin.append('<option value="' + price + '">' + this.__FilterDTO.currencyPriceList[i] + '</option>');
            }
        }
        if (actualSelected < currentPrice) {
            this.__$pvpMin.val(actualSelected);
        }
    };

    var __updatePvpMax = function (currentPrice) {
        var self = this;
        var actualSelected = parseInt(this.__$pvpMax.children(':selected')[0].value);
        currentPrice = parseInt(currentPrice);
        this.__$pvpMax.html('');
        for (var i = 0; i<this.__FilterDTO.priceList.length; i++) {
            if (i === 0) {
                self.__$pvpMax.append('<option value="0">Sin límite</option>');
            }
            var price = this.__FilterDTO.priceList[i];
            if (parseInt(price) > currentPrice || currentPrice === 0) {
                self.__$pvpMax.append('<option value="' + price + '">' + this.__FilterDTO.currencyPriceList[i] + '</option>');
            }
        }
        if (actualSelected > currentPrice) {
            this.__$pvpMax.val(actualSelected);
        }
    };

    var __loadModalZonas = function (FilterDTO) {
        var codPais = jquery("#FiltrosViewModel_Filtros_Geo_CodPais").val();
        var codProv = jquery("#FiltrosViewModel_Filtros_Geo_CodProv").val();
        var codCom = jquery("#FiltrosViewModel_Filtros_Geo_CodCom").val();
        var codArea = jquery("#FiltrosViewModel_Filtros_Geo_CodArea").val();
        var codPob = jquery("#FiltrosViewModel_Filtros_Geo_CodPob").val();

        var req = jquery.ajax({
            url: FilterDTO.urlModalZonasAjax,
            data: {
                codPais: codPais,
                codProv: codProv,
                codCom: codCom,
                codArea: codArea,
                codPob: codPob
            },
            type: 'POST',
            dataType: "html",
            cache: false
        });

        req.done(function (data) {
            if (data) {
                var $elementoHtmlZonas = jquery("#html-zonas");
                var $elementoModalZonas = jquery("#modal-zonas");

                if ($elementoHtmlZonas.length > 0) {
                    $elementoHtmlZonas.html(data);
                } else {
                    $elementoModalZonas.after('<div id="html-zonas" style="display:none"></div>');
                    $elementoHtmlZonas = jquery("#html-zonas");
                }
                $elementoHtmlZonas.append(data);
            }

        });

        req.fail(function (request, type) {
            console.log(request);
            console.log(type);
        });
    };


    var __getStringFromArray = function (array, field) {
        var result = "";

        for (var i = 0, length = array.length; i < length; i++) {
            var element = array[i];

            result += element[field];

            if (i !== length - 1) {
                result += ",";
            }
        }

        return result;
    };

    var __setZonasSeleccionadas = function (poblacion, distritos, zonas) {

        var lista_zonas = jquery("#SelectZona").children("ul");
        lista_zonas.empty();

        if (poblacion.length > 0) {
            lista_zonas.append(jquery("<li>Todas</li>"));
        }
        else {
            if (distritos.length > 0){
                for (var i = 0, length = distritos.length; i < length; i++) {

                    var distrito = distritos[i];
                    var numeroZonasPorDistrito = jquery("#modal-zonas #ul-d-" + distrito.codDist + " input:checkbox.z").length;
                    var elementoLista = null;
                    if (numeroZonasPorDistrito === distrito.numZonasSeleccionadas) {
                        elementoLista = jquery("<li>" + distrito.nomDist + "</li>");
                    } else {
                        var contenido = "<li>" + distrito.nomDist + ": ";

                        for (var j = 0, lengthJ = zonas.length; j < lengthJ ; j++) {
                            var zona = zonas[j];
                            var mostrar = jquery("#z-" + zona.codZona + "-" + distrito.codDist).length > 0;

                            if (mostrar) {
                                contenido += zona.nomZona + ", ";
                            }
                        }

                        if (contenido[contenido.length - 1] === " ") {
                            contenido = contenido.substring(0, contenido.length - 2);
                        }
                        contenido += "</li>";

                        elementoLista = jquery(contenido);
                    }
                    lista_zonas.append(elementoLista);
                }
            }
            else {
                for (var k = 0, lengthK = zonas.length; k < lengthK ; k++) {
                    var zonaK = zonas[k];
                    var elementoListaK = null;
                    elementoListaK = jquery("<li>" + zonaK.nomZona + "</li>");
                    lista_zonas.append(elementoListaK);
                }
            }
            
        }
    };


    var __registerEventsModalZonas = function () {
        var self = this;

        jquery('#modal-zonas #z-all').on('click', function () {
            var all = jquery(this);
            var value = all.is(":checked");          
            __checkUnckeckAll.call(self, value);

        });

        jquery("#modal-zonas .d").click(function () {

            var distrito = jquery(this);
            var coddist = distrito.attr("data-coddist");

            var value = distrito.is(":checked");
            __CheckZonasDeUnDistrito(distrito, value);

            var numzonas = __getNumZonasPorDistrito(coddist);
            var numzonasSeleccionadas = __getNumZonasSelecionadasPorDistrito(coddist);
            __CheckDistrito(coddist, numzonas, numzonasSeleccionadas);

            var numZonasSelecionados = __getNumZonasSeleccionados();
            __CheckAll(numZonasSelecionados);
        });

        jquery("#modal-zonas .z").click(function () {

            var value = jquery(this).is(":checked");
            __CheckZona(jquery(this), value);

            var coddist = this.attributes["data-coddist"].value;
            if (coddist !== "0") {
                var numzonas = __getNumZonasPorDistrito(coddist);
                var numzonasSeleccionadas = __getNumZonasSelecionadasPorDistrito(coddist);
                __CheckDistrito(coddist, numzonas, numzonasSeleccionadas);
            }

            var numZonasSelecionados = __getNumZonasSeleccionados();
            __CheckAll(numZonasSelecionados);
        });

        jquery("#modal-zonas .btnmostrar").on("click", function (e) {
            e.stopPropagation();
            e.preventDefault();
            var idUlDistrito = this.attributes["data-distrito"].value;
            var ul = jquery("#" + idUlDistrito);
            if (ul.hasClass("ocultar")) {
                jquery(this).removeClass("desplegar").addClass("contraer");
                ul.removeClass("ocultar").addClass("mostrar");
            } else {
                jquery(this).removeClass("contraer").addClass("desplegar");
                ul.removeClass("mostrar").addClass("ocultar");
            }
        });
    };

    var __getZonasSeleccionadas = function () {
        var zonasSeleccionadas = window.FilterMapDTO.selectedZones.filter(function (location) {
            return location.type === 'zone';
        }).map(function (location) {
            return { codZona: location.id, nomZona: location.name };
        });

        return zonasSeleccionadas;
    };

    var __getPoblacionSeleccionada = function () {
        var poblacionSeleccionada = window.FilterMapDTO.selectedZones.filter(function (location) {
            return location.type === 'town';
        }).map(function (location) {
            return { codPob: location.id, nomPob: location.name };
        });

        return poblacionSeleccionada;
    };


    var __getDistritosSeleccionados = function () {
        var distritos = [...window.FilterMapDTO.selectedZones, ...window.FilterMapDTO.halfSelectedZones];
        var distritosSeleccionadas = distritos.filter(function (location) {
            return location.type === 'district';
        }).map(function (location) {
            return { codDist: location.id, nomDist: location.name };
        });

        return distritosSeleccionadas;
    };

    var __getNumZonasSeleccionados = function (zonasSeleccionadas) {
        return zonasSeleccionadas.length || 0;
    };

    var __getNumZonasPorDistrito = function (coddist) {
        var numzonas = jquery("#modal-zonas  #ul-d-" + coddist).attr("data-zonas");
        return parseInt(numzonas);
    };

    var __getNumZonasSelecionadasPorDistrito = function (coddist) {
        var num = 0;
        var distritos = jquery("#modal-zonas  #ul-d-" + coddist + " input:checkbox");
        distritos.each(function (i, distrito) {
            if (distrito.value === "1") {
                num++;
            }
        });
        return num;
    };

    var __CheckAll = function (numZonasSelecionados) {

        var numzonas = jquery("#modal-zonas  input:checkbox.z").length;
        var all = jquery("#modal-zonas  #z-all");
        var spanall = jquery("#modal-zonas #l-z-all");
        spanall.removeAttr("class");

        if (numZonasSelecionados === numzonas) {
            all.val("1");
            spanall.addClass("l-z-all zonaseleccionada");
        }
        else if (numZonasSelecionados >= 1) {
            all.val("1");
            spanall.addClass("l-z-all zonanoseleccionada algoseleccionado");
        }
        else if (numZonasSelecionados === 0) {
            all.val("0");
            spanall.addClass("l-z-all zonanoseleccionada");
        }
    };

    var __CheckDistrito = function (coddist, numzonas, numzonasSeleccionadas) {

        var d = jquery("#modal-zonas  #d-" + coddist);
        var spannomdist = jquery("#modal-zonas #span-nomdist-" + coddist);
        var spanselecteddist = jquery("#modal-zonas #span-selectedsdist-" + coddist);

        d.removeAttr("class");
        //spannomdist.removeAttr("class");

        if (numzonasSeleccionadas > 0 && numzonasSeleccionadas === numzonas) {
            spannomdist.removeAttr("class");
            d.val("1");
            d.addClass("d zonaseleccionada");
            spannomdist.addClass("zonaseleccionada");
            spanselecteddist.text("(Todas)");
        }
        else if (numzonasSeleccionadas >= 1) {
            spannomdist.removeAttr("class");
            d.val("1");
            d.addClass("d algoseleccionado");
            spannomdist.addClass("zonaseleccionada");
            spanselecteddist.text("(" + numzonasSeleccionadas + ")");
        }
        else if (numzonasSeleccionadas === 0) {
         

            if ($(spannomdist).hasClass('zonaseleccionada')) {
                d.val("0");
                d.addClass("d");
                spannomdist.removeAttr("class");
                spannomdist.addClass("zonanoseleccionada");
            } else {
               d.val("1");
               d.addClass("d");
               d.prop("checked");
               spannomdist.removeAttr("class");
               spannomdist.addClass("zonaseleccionada");
            }
            spanselecteddist.text("");
          
           
        }
    };

    var __CheckZonasDeUnDistrito = function (distrito, value) {
        var codDist = distrito.attr("data-coddist");
        __CheckZonasDeUnDistrito_PorCodDist(codDist, value);
    };

    var __CheckZonasDeUnDistrito_PorCodDist = function (codDist, value) {
        var zonas = jquery("#ul-d-" + codDist + " input:checkbox");
      
        if (value === true) { // ===1
            
            

            zonas.each(function (i, zona) {
                __CheckZona(jquery(zona), true);
            });
        }
        else if (value === false) {//=== 0
            zonas.each(function (i, zona) {
                __CheckZona(jquery(zona), false);
            });
        }
    };

    var __CheckZona = function (zona, value) {

        var labelid = zona.attr("data-labelfor");
        zona.prop("checked", value);
        if (value === true) {  //=== 1
            zona.val("1");
            jquery("#" + labelid).removeClass("zonanoseleccionada").addClass("zonaseleccionada");
        }
        else if (value === false) {//=== 0

            zona.val("0");
            jquery("#" + labelid).removeClass("zonaseleccionada").addClass("zonanoseleccionada");
        }
    };

    var __checkUnckeckAll = function (checkOruncheck) {
        var value = "";
        var cssAddClass = "";
        var cssRemoveClass = "";
        if (checkOruncheck) {
            value = "1";
            cssAddClass = "zonaseleccionada";
            cssRemoveClass = "zonanoseleccionada";
        } else {
            value = "0";
            cssAddClass = "zonanoseleccionada";
            cssRemoveClass = "zonaseleccionada";
        }


        var $labelTodos = jquery("#modal-zonas #l-z-all");

        $labelTodos.addClass(cssAddClass);
        $labelTodos.removeClass(cssRemoveClass);
        $labelTodos.removeClass("algoseleccionado");
        
        var distritos = jquery("#modal-zonas input:checkbox.d");

        for (var i = 0, length = distritos.length; i < length; i++){
            var $distrito = jquery(distritos[i]);
            $distrito.val(value);
            $distrito.prop("checked", checkOruncheck);
            $distrito.removeClass(cssRemoveClass);
            $distrito.removeClass("algoseleccionado");
            $distrito.addClass(cssAddClass);
            jquery("#modal-zonas #span-selectedsdist-" + $distrito.attr("data-coddist")).text("");
            jquery("#modal-zonas #span-nomdist-" + $distrito.attr("data-coddist")).removeClass(cssRemoveClass);
            jquery("#modal-zonas #span-nomdist-" + $distrito.attr("data-coddist")).addClass(cssAddClass);
        }

        var zonas = jquery("#modal-zonas input:checkbox.z");

        for (var j = 0, lengthZ = zonas.length; j < lengthZ; j++) {
            var $zona = jquery(zonas[j]);
            $zona.val(value);
            $zona.prop("checked", checkOruncheck);
            $zona.parent().addClass(cssAddClass);
            $zona.parent().removeClass(cssRemoveClass);
        }
    };

    var __InitZonas_De_DistritoSeleccionado = function () {
        var codZonasSel = jquery("#FiltrosViewModel_Filtros_CodZonas").val();
        var codDistsSel = jquery("#FiltrosViewModel_Filtros_CodDistritos").val();
        if (codZonasSel === "" && codDistsSel !== "") {
            __CheckZonasDeUnDistrito_PorCodDist(codDistsSel, true);
            var spanselecteddist = jquery("#modal-zonas #span-selectedsdist-" + codDistsSel);

           if (codZonasSel === 0 || codZonasSel === "") {
                 spanselecteddist.text("");
            }
            else
            {
                 spanselecteddist.text("(Todas)");
            }
        }
    };

    FilterIndex.prototype = {
        constructor: FilterIndex
    };

    if (typeof module !== 'undefined' && module.exports) {
        module.exports.FilterIndex = new FilterIndex(FilterIndexDTO);
    }
    else {
        window.FilterIndex = new FilterIndex(FilterIndexDTO);
    }
}());